import { string } from 'fp-ts';
import { pipe } from 'fp-ts/function';
import { BankAccount } from '@mews-commander/data-access';
import { MAX_BANK_NAME_LENGTH, OMISSION_STRING } from './constants';

export const bankNameMaxLengthExceeded = (bankName: BankAccount['bankName']) =>
    bankName ? pipe(bankName, string.size) > MAX_BANK_NAME_LENGTH : false;

export const getTruncatedBankName = (bankName: BankAccount['bankName']) =>
    bankName
        ? pipe(bankName, string.slice(0, MAX_BANK_NAME_LENGTH)).padEnd(
              MAX_BANK_NAME_LENGTH + OMISSION_STRING.length,
              OMISSION_STRING
          )
        : '';
